interface LeadData {
  name: string
  email: string
  phone: string,
  source: string
}

const postLead = async (data: LeadData, context: string): Promise<void> => {
  try {
    const { name, email, phone, source } = data

    const payload = {
      name,
      email,
      phone,
      source,
      interest: 'cliente'
    };

    const response = await fetch(
      `${process.env.REACT_APP_API_URL}leads`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      },
    );

    if (!response.ok) {
      // Não lançar erro, apenas logar
      console.warn(`Erro ao salvar lead (${context}):`, response.statusText);
    }
  } catch (error) {
    // Não bloquear o fluxo se houver erro
    console.warn(`Erro ao salvar lead (${context}):`, error);
  }
};

/**
 * Salva o lead na API
 */
export const saveLeadFromDrMonitora = (data: LeadData): Promise<void> =>
  postLead(data, 'DrMonitora');

export const saveLeadFromCheckout = (data: LeadData): Promise<void> =>
  postLead(data, 'checkout');
